import React from 'react';

import { TAG_COLORS } from '@/features/assets/constants';

const SingleListItem = ({ title, value, isTagList, tagList }) => {
	return (
		<div>
			<li className="regular-12 d-flex justify-content-start">
				<span className="subtitle gray_dark_05">{title}</span>
				<span className="clone">:</span>
				{isTagList ? (
					<span className="d-flex flex-wrap gap-1">
						{tagList.map((tag, index) => (
							<span
								key={index}
								className="status"
								style={{ background: TAG_COLORS[index % TAG_COLORS.length] }}
							>
								{tag.text}
							</span>
						))}
					</span>
				) : (
					<span className="sub-info gray_dark_01 weight-500">{value}</span>
				)}
			</li>
		</div>
	);
};

export default SingleListItem;
